import React, { useState, useEffect, useRef } from "react";
import {Link } from 'react-router-dom'
import axiosInstance from "../../services/api";
import { useHistory } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import Loader from '../Commons/Loader';
function EditHotel() {
    const history = useHistory();
    const [isCheckedEnable, setIsCheckedEnable] = useState(false);
    const [hotelFetchData, setHotelFetchData] = useState([]);
    const [errors, setErrors] = useState({});
    const [subHotel, setSubHotel] = useState([]);
    const [editFetchHotelData, setEditFetchHotelData] = useState();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const id = location.pathname.split("/").pop();
    const [file, setFiles] = useState([]);
    const [exfile, setExFile] = useState(null);
    const fileInputRef = useRef();
    const [formData, setFormData] = useState({
        hubRegistrationId: "",
        hotelName: "",
        hotelGroup: "",
        hotelSubGroup: "",
        stbCount: "",
        roomCount: "",
        file: "",
        exfile: ""
    });
   
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    // if (!formData.hubRegistrationId) {
    //   tempErrors.hubRegistrationId = "Please enter Registration Id";
    //   isValid = false;
    // }

    if (!formData.hotelName) {
        tempErrors.hotelName = "Please enter hotel name";
        isValid = false;
    }
    if (!formData.hotelGroup) {
        tempErrors.hotelGroup = "Please Select hotel group";
        isValid = false;
    }
    if (!formData.stbCount) {
        tempErrors.stbCount = "Please type stb count";
        isValid = false;
    }
    if (!formData.roomCount) {
        tempErrors.roomCount = "Please type room count";
        isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

    const fetchUserData = async () => {
        try {
            const response = await axiosInstance.get('hotel/hotel-groups.json'); // Fetch data
            setHotelFetchData(response.data.data.groups);
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally {
            setLoading(false);
          }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    const fetchHotelData = async () => {
        try {
            const response = await axiosInstance.get(`hotel/add-edit-hotel.json?id=${id}`);
            setEditFetchHotelData(response.data.data.hotel)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchHotelData();
    }, []);
    useEffect(() => {
    
    }, [hotelFetchData]);
    useEffect(() => {
        if (editFetchHotelData) {
            console.log(editFetchHotelData.signOffRoomCount,"editFetchHotelData 321")
            setFormData({
                id: editFetchHotelData.id || null,
                hubRegistrationId: editFetchHotelData.hubRegistrationId || null,
                hotelName: editFetchHotelData.hotelName || null,
                hotelGroup: editFetchHotelData.hotelGroup || null,
                hotelSubGroup: editFetchHotelData.hotelSubGroup || null,
                stbCount: editFetchHotelData.signOffStbCount?.toString() ?? '',
                roomCount: editFetchHotelData.signOffRoomCount?.toString() ?? '',
            });
            // setExFile(editFetchHotelData.signOffRooms);
            // setFiles(editFetchHotelData.documentLinks)
            setIsCheckedEnable(editFetchHotelData.enabled ?? false);  // Default to true if not provided
        }
    }, [editFetchHotelData]);


    

    useEffect(() => {
        if (formData.hotelGroup) {
          const selectedGroup = hotelFetchData.find(
            (group) => group.name === formData.hotelGroup
          );
          
          const filteredSubHotels = selectedGroup?.subGroups || [];
          setSubHotel(filteredSubHotels);
    
          // Auto-select sub-group if available
          if (editFetchHotelData && editFetchHotelData.hotelSubGroup) {
            const existingSubGroup = filteredSubHotels.find(
              (sub) => sub.name === editFetchHotelData.hotelSubGroup
            );
            console.log(existingSubGroup,"existingSubGroup")
            setFormData((prev) => ({
              ...prev,
              hotelSubGroup: existingSubGroup ? existingSubGroup.name : "",
            }));
          }
        }
      }, [formData.hotelGroup, hotelFetchData, editFetchHotelData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    if (name === "hotelGroup") {
        // Find selected hotel's sub-groups
        const selectedGroup = hotelFetchData.find((group) => group.name === value);
        const filteredSubHotels = selectedGroup?.subGroups || [];
  
        setSubHotel(filteredSubHotels);
  
        // Auto-select first sub-group if available
        setFormData((prev) => ({
          ...prev,
          hotelSubGroup: filteredSubHotels.length > 0 ? filteredSubHotels[0].name : "",
        }));
    }
  };


  const handleChangeEnableToggle = () => {
    setIsCheckedEnable(!isCheckedEnable);
  };

  
  const handleSubmit = async (e) => {
    toast.dismiss();
    e.preventDefault();

    if (validate()) {
        setLoading(true);
        try {
                // const payload = {
                //     ...formData,
                //     enabled: isCheckedEnable,  // Fixed key name here
                // };

                // const response = await axiosInstance.post('hotel/save-hotel', payload);
                // //history.push('/all-user'); 
                // if (response.status === 200) {
                //     if(response.data.status.code===200) {
                //         toast.success(response.data.status.message);
                //         setTimeout(() => {
                //             history.push('/all-hotels');
                //         }, 2000);
                //     }else{
                //         toast.error(response.data.status.message);
                //     }
                // }
                const formDataToSend = new FormData();
                const hotelBean = {
                    id : formData.id,
                    hubRegistrationId:formData.hubRegistrationId,
                    hotelName: formData.hotelName,
                    hotelGroup: formData.hotelGroup,
                    hotelSubGroup: formData.hotelSubGroup,
                    enabled: isCheckedEnable,
                    signOffRoomCount: formData.roomCount,
                    signOffStbCount: formData.stbCount,
                    documentLinks: [],
                    signOffRooms: [],
                };
                console.log(hotelBean,"hotelBean")
                const hotelBeanBlob = new Blob([JSON.stringify(hotelBean)], { type: "application/json" });
                formDataToSend.append("hotelBean", hotelBeanBlob);
                //formDataToSend.append('hotelBean', JSON.stringify(hotelBean));
                console.log(exfile,"exfile")
                if (exfile) {
                    formDataToSend.append('roomExcel', exfile);
                }

                // Append multiple files under documents.file
                if (file && file.length > 0) {
                    file.forEach((f, idx) => {
                        console.log(f,"fdd")
                        formDataToSend.append(`documents`, f);
                    });
                }
                const response = await axiosInstance.post('hotel/save-hotel', formDataToSend, {
                    headers: {
                        // Don't set 'Content-Type' here
                        // The browser will set something like:
                        // multipart/form-data; boundary=----WebKitFormBoundary...
                    }
                });
                //setIsCheckedEnable(false);
                if (response.status === 200) {
                    if(response.data.status.code===200) {
                        toast.success(response.data.status.message);
                        setTimeout(() => {
                            history.push('/all-hotels');
                        }, 2000);
                    }else{
                        toast.error(response.data.status.message);
                    }
                }
            } catch (error) {
                console.error('Error validating OTP:', error);
            }finally {
                setLoading(false);
              }
    }
  };

  const handleDownloadExcelFormat = async (e) => {
     setLoading(true);

        try {
            setLoading(true);
            const response = await axiosInstance.get(
                `hotel/download-room-list-sample`,
                {
                    responseType: "blob", // Handle binary data correctly
                    timeout: 120000, // Timeout set to 120 seconds (120000 ms)
                }
            );
          const contentType = response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      
          // Create a Blob from the response data
          const blob = new Blob([response.data], { type: contentType });
      
          // Generate a temporary URL for the file
          const downloadUrl = window.URL.createObjectURL(blob);
      
          // Create a hidden <a> element to trigger the download
          const link = document.createElement("a");
          link.href = downloadUrl;
      
          const DownloadFileName = `room-excel-sample`;
          link.setAttribute("download", DownloadFileName);
      
          document.body.appendChild(link);
          link.click();
      
          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error("Error fetching report data:", error);
        } finally {
            setLoading(false);
        }
  }
  const handleExFileChange = (e) => {
    const selectedExFile = e.target.files[0];
    setExFile(selectedExFile);
    setFormData(prev => ({ ...prev, exfile: setExFile }));
    setErrors(prev => ({ ...prev, exfile: "" }));
};


const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);

    // Merge new files with existing ones, avoiding duplicates (optional)
    const updatedFiles = [...file, ...newFiles];

    setFiles(updatedFiles);
    setFormData(prev => ({ ...prev, file: updatedFiles }));
    setErrors(prev => ({ ...prev, file: "" }));
 };

    return (
        <>
            {loading && <Loader />} 
            <div className="content-header">
                <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6 title-mob">
                    <h1 className="m-0">Edit Hotel</h1>
                    <Link className="btn btn-primary submit-btn" to="/all-hotels">All Hotels</Link>
                    </div>{/* /.col */}
                    <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                        <li className="breadcrumb-item mob-hide"><Link to="/all-hotels">All Hotels</Link></li>
                        <li className="breadcrumb-item active">Edit Hotel</li>
                    </ol>
                    </div>{/* /.col */}
                </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            <section className="content">
                {/* <h2>Enter your Details</h2> */}
                <div className="container-fluid border-top pt-4">
                    <form className="row">
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                                <label>Hub Registration ID</label>
                                <input type="text" className="input-fld" name="hubRegistrationId" value={formData.hubRegistrationId} onChange={handleChange} />
                                {/* {errors.hubRegistrationId && <span className="error">{errors.hubRegistrationId}</span>}
                                {errors.userType && <span className="error">{errors.userType}</span>} */}
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                                <label>Hotel Name <span>*</span></label>
                                <input type="text" className="input-fld" name="hotelName" value={formData.hotelName} onChange={handleChange} />
                                {errors.hotelName && <span className="error">{errors.hotelName}</span>}
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                                <label>Hotel Group <span>*</span></label>
                                <select className="select-fld" name="hotelGroup" value={formData.hotelGroup} onChange={handleChange}>
                                    <option value="">Select Hotel Group</option>
                    
                                    {hotelFetchData.length > 0 && hotelFetchData.map((item, index) => (
                                        <option key={index} value={item.name
                                        }>{item.displayName}</option>
                                    ))}
                                </select>
                                {errors.hotelGroup && <span className="error">{errors.hotelGroup}</span>}
                            </div>
                        </div>
                            
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                                <label>Hotel Sub Group </label>
                                <select className="select-fld" name="hotelSubGroup" value={formData.hotelSubGroup} onChange={handleChange}>
                                    <option value="">Select Hotel Sub Group</option>
                                    {subHotel.length > 0 && subHotel.map((item, index) => (
                                        <option key={index} value={item.name
                                        }>{item.displayName}</option>
                                    ))}
                                    {/* {subHotel.length > 0 ? (
                                        subHotel.map((item, index) => (
                                            <option key={index} value={item.name}>{item.name}</option>
                                        ))
                                    ) : (
                                        <option disabled>No sub-hotels available</option>
                                    )} */}
                                </select>
                            </div>
                        </div>

                        <div className="col-lg-6 col-12">
                            <div className="row">
                                <div className="col-lg-6 col-12">
                                    <div className="form-group">
                                        <label>Room Count <span>*</span></label>
                                        <input type="text" className="input-fld" name="roomCount" value={formData.roomCount} onChange={handleChange} />
                                        {errors.roomCount && <span className="error">{errors.roomCount}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-12">
                                    <div className="form-group">
                                        <label>STB Count <span>*</span></label>
                                        <input type="text" className="input-fld" name="stbCount" value={formData.stbCount} onChange={handleChange} />
                                        {errors.stbCount && <span className="error">{errors.stbCount}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                                <label>Room Number <i onClick={handleDownloadExcelFormat} className="nav-icon fas fa-eye color-orange" title="upload excel sample format"></i></label>
                                    {/* <input type="text" className="input-fld" name="roomNumber" value={formData.roomNumber} onChange={handleChange} /> */}
                                    <div className="w-full px-2 py-2 text-gray-600 border-2 border rounded-lg transition duration-300 text-center custom-upload custom-border-color">

                                    <label className="block cursor-pointer mb-0">
                                        <div className="flex items-center">
                                  
                                            <svg
                                                className="w-8 h-8 text-blue-500"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 7.5V6.75A2.25 2.25 0 015.25 4.5h3.086a2.25 2.25 0 011.59.659l.83.83a2.25 2.25 0 001.59.659h5.114A2.25 2.25 0 0120.25 9v1.5M3 7.5h18M3 7.5v10.125A2.625 2.625 0 005.625 20.25h12.75A2.625 2.625 0 0021 17.625V9" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 11.25v5.25m0 0l-1.5-1.5m1.5 1.5l1.5-1.5" />
                                            </svg>
                                            <p className="text-sm click-to-upload">upload excel file</p>

                                            <input
                                                type="file"
                                                className="hidden"
                                                onChange={handleExFileChange}
                                                name="exfile"
                                                accept=".xlsx"
                                                ref={fileInputRef}
                                            />
                                        </div>
                                        
                                    </label>
                                    {exfile && (
                                        <div className="mt-4 text-sm text-gray-700 selected-file-nme">
                                            <span><strong>Selected file:</strong> {exfile.name}</span>
                                        </div>
                                    )}
                                    {errors.exfile && <span className="error">{errors.exfile}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-12">
                            <div className="form-group">
                                <label>Uploaded Room Numbers</label>
                                <div className="uploaded-room-number-blk">
                                    {editFetchHotelData && editFetchHotelData.signOffRooms?.join(', ')}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12 col-12">
                            <div className="form-group">
                                <label>Uploaded Documents</label>
                                <ul className="uploaded-document">
                                    {editFetchHotelData?.documentLinks?.map((link, idx) => {
                                        const fileName = link.split('/').pop();
                                        const extension = fileName.split('.').pop().toLowerCase();

                                        const getIconSvg = (ext) => {
                                            switch (ext) {
                                                case 'pdf':
                                                return (
                                                    <svg width="30" height="30" viewBox="0 0 24 24" fill="red">
                                                    <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm9 0v5h5" />
                                                    <text x="7" y="17" fontSize="8" fill="white">PDF</text>
                                                    </svg>
                                                );
                                                case 'doc':
                                                case 'docx':
                                                return (
                                                    <svg width="30" height="30" viewBox="0 0 24 24" fill="#2b579a">
                                                    <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm9 0v5h5" />
                                                    <text x="6" y="17" fontSize="8" fill="white">DOC</text>
                                                    </svg>
                                                );
                                                case 'xlsx':
                                                case 'xls':
                                                return (
                                                    <svg width="30" height="30" viewBox="0 0 24 24" fill="green">
                                                    <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm9 0v5h5" />
                                                    <text x="6" y="17" fontSize="8" fill="white">XLS</text>
                                                    </svg>
                                                );
                                                case 'jpg':
                                                case 'jpeg':
                                                case 'png':
                                                return (
                                                    <svg width="30" height="30" viewBox="0 0 24 24" fill="#f0c419">
                                                    <path d="M4 4h16v16H4z" stroke="black" strokeWidth="1" />
                                                    <circle cx="8" cy="8" r="2" fill="#000" />
                                                    <path d="M4 20l5-6 5 4 4-5 4 7z" fill="#000" />
                                                    </svg>
                                                );
                                                default:
                                                return (
                                                    <svg width="30" height="30" viewBox="0 0 24 24" fill="#999">
                                                    <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm9 0v5h5" />
                                                    <text x="6" y="17" fontSize="8" fill="white">FILE</text>
                                                    </svg>
                                                );
                                            }
                                        };

                                        return (
                                        <li className="shadow-sm flex items-center gap-2" key={idx}>
                                            <a
                                            href={link}
                                            download={fileName}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center gap-2"
                                            >
                                                {getIconSvg(extension)}
                                                {fileName}
                                            </a>
                                        </li>
                                        );
                                    })}
                                </ul>

                            </div>
                        </div>

                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                                <label>Documents</label>
                                <div className='relative input-fld-group'>
                                    <div className="w-4/5 mt-2 px-4 py-8 text-gray-600 border-2 border-dashed rounded-lg shadow-sm hover:bg-gray-50 transition duration-300 text-center custom-upload">

                                    <label className="block cursor-pointer">
                                        <div className="flex items-center justify-center">
                                        <div className="text-center">
                                        <svg
                                            className="w-12 h-12 mx-auto mb-2 text-blue-500"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 7.5V6.75A2.25 2.25 0 015.25 4.5h3.086a2.25 2.25 0 011.59.659l.83.83a2.25 2.25 0 001.59.659h5.114A2.25 2.25 0 0120.25 9v1.5M3 7.5h18M3 7.5v10.125A2.625 2.625 0 005.625 20.25h12.75A2.625 2.625 0 0021 17.625V9" />
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 11.25v5.25m0 0l-1.5-1.5m1.5 1.5l1.5-1.5" />
                                        </svg>
                                            <p className="text-sm click-to-upload">Click to upload or drag a file here</p>
                                            <p className="text-sm add-more-files"><i className="fas fa-plus-circle"></i> Add More Files</p>
                                        </div>
                                        <input
                                            type="file"
                                            className="hidden"
                                            onChange={handleFileChange}
                                            name="file"
                                            multiple
                                            ref={fileInputRef}
                                        />
                                        </div>
                                    </label>

                                    {file.length > 0 && (
                                        <div className="mt-4 text-sm text-gray-700">
                                            <strong>Selected files:</strong>
                                            <ul className="mt-2 list-disc list-inside file-listing">
                                            {file.map((file, index) => (
                                                <li key={index}>{file.name}</li>
                                            ))}
                                            </ul>
                                        </div>
                                    )}

                                    </div>
                                    {errors.file && <span className="error">{errors.file}</span>}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12 col-12">
                            <div className="form-group d-flex items-center gap-5">
                                <label className="mb-0">Enabled</label>
                                <label className="switch">
                                    <input 
                                    type="checkbox" 
                                    checked={isCheckedEnable} 
                                    onChange={handleChangeEnableToggle} 
                                    />
                                    <span className="slider"></span>
                                </label>
                                <p>Status: {isCheckedEnable ? 'ON' : 'OFF'}</p>                     
                            </div>
                        </div>
                        
                        <div className="col-lg-2 col-6">
                            <button onClick={handleSubmit} className="btn btn-primary submit-btn">Submit</button>
                        </div>

                    </form>
                </div>{/* /.container-fluid */}
            </section>
        </>
    );
}
  
export default EditHotel;